export const SUPPORT_EMAIL = "support@masteryprep.com"
